import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Button } from '@flatfy/supernova-new';
import { attachGaDataAttributes } from '../../helpers/analytics';
import { useFilterReset } from '../FlatsFiltersReset/useFilterReset';
import { FlatsFiltersContentContext } from '../FlatsFiltersContext';

const FlatsFiltersActions = ({ skipKeys, onClose }) => {
  const { flatsCount } = useContext(FlatsFiltersContentContext);
  const { handleResetClick } = useFilterReset(skipKeys);

  return (
    <div className="FlatsFiltersActions">
      <Button
        variant="secondary-outline"
        onClick={() => {
          handleResetClick();
          onClose();
        }}
        classes={{
          content: 'FlatsFiltersActions-buttonContent',
        }}
        fullWidth
        {...attachGaDataAttributes({
          category: window.eventCategory,
          action: 'filters',
          label: 'reset_click',
        })}
      >
        <FormattedMessage id="reset" />
      </Button>
      <Button
        variant="primary"
        onClick={onClose}
        classes={{
          content: 'FlatsFiltersActions-buttonContent',
        }}
        fullWidth
        {...attachGaDataAttributes({
          category: window.eventCategory,
          action: 'filters',
          label: 'show_click',
        })}
      >
        <FormattedMessage id="resultsCount" values={{ count: flatsCount }} />
      </Button>
    </div>
  );
};

FlatsFiltersActions.propTypes = {
  skipKeys: PropTypes.array,
  onClose: PropTypes.func,
};

export default FlatsFiltersActions;
